<template>
  <div>
    <div>
      <router-view/>
    </div>
  </div>

</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex'

  export default {
    computed: mapState([
      'abstract', 'status', 'authors', 'theme_list', 'user'
    ]),
    methods: {
      ...mapActions([
        'GET_USERDATA'
      ]),
      ...mapMutations([
        'SET_USER'
      ]),
    },
    created() {
      this.$store.dispatch('GET_ONE_ABSTRACT', this.$route.params.id);
      this.$store.dispatch('GET_AUTHORS', this.$route.params.id);
      this.$store.dispatch('GET_ALL_GENDER');
      this.$store.dispatch('GET_ALL_SALUTATIONS');
      this.$store.dispatch('GET_ALL_DATAHELPER');
      if (!this.user || !this.user.id) {
        this.GET_USERDATA().then((result) => {
          this.SET_USER({user: result.data})
        })
      }
    }
  }
</script>

